import { render, staticRenderFns } from "./product-add-edit-component.vue?vue&type=template&id=4083a752&scoped=true&lang=pug"
import script from "./product-add-edit-component.js?vue&type=script&lang=js&external"
export * from "./product-add-edit-component.js?vue&type=script&lang=js&external"
import style0 from "./product-add-edit-component.vue?vue&type=style&index=0&id=4083a752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083a752",
  null
  
)

export default component.exports